module.exports = __webpack_public_path__ + "images/vehicle.535dd29ade31ba9c9fb33f1ae1707883.svg";